/* eslint-disable no-undef,no-empty */
import $ from 'jquery';
import moment from 'moment';
import numeral from 'numeral';
import Vue from 'vue';
import VueMask from 'v-mask'

import VueScrollTo from 'vue-scrollto';
import VModal from 'vue-js-modal'
import VueCarousel from 'vue-carousel';

import store from './store';
import * as Actions from './store/action-types';

require('flag-icon-css/sass/flag-icon.scss');
require('./css/styles.scss');

moment.locale('es');
window.moment = moment;
window.Promise = require('promise');

window.Form = {};

if (process.env.NODE_ENV !== 'production') {
    console.group(' ---- ENVIRONMENT INFORMATION ----');
    console.log(`NODE_ENV: ${process.env.NODE_ENV}`);
    console.log(`BASE_URL: ${process.env.ENDPOINT_BASE_URL}`);
    console.groupEnd();
}

numeral.register('locale', 'ch', {
    delimiters: {
        thousands: '.',
        decimal: ','
    },
    currency: {
        symbol: '$'
    }
});

numeral.locale('ch');
window.numeral = numeral;

Vue.config.productionTip = true;

Vue.use(VueScrollTo);
Vue.use(VModal)
Vue.use(VueCarousel);
Vue.use(VueMask);

try {
    window.$ = window.jQuery = $;

    $.ajaxSetup({
        contentType: "application/json",
    });

    $(function () {
        $('.valle--popover').popover({
            trigger: 'hover',
            placement: 'bottom',
        });
    });

    require('bootstrap');
} catch (e) {
    console.error(e);
}

window.Vue = Vue;
window.Bus = new Vue();

require('./filters');
require('./components/bootstrap');

const routes = ['/flex', '/fix'];

new Vue({
    store,

    mounted() {
        const route = window.location.pathname;

        if (!routes.includes(route)) {
            this.$store.dispatch(Actions.restoreCart);
        } else {
            if (route === routes[0]) this.$store.dispatch(Actions.getTicketsAndCart);
        }
    }
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js